import { Device } from '@twilio/voice-sdk';

/**
 * Externalize the twilio device functions into a separeted file to
 * allow call disconnection from everywhere in the code.
 *
 * NOTE: Could not be added to the voip store module as the twilio-client
 * library makes changes to the object that are outside of mutations
 */
export let twilioDevice = null;

// Use object for connection to ensure propper data update/binding
export let twilioConnection = { connection: null };

export function setConnection(connection) {
  twilioConnection.connection = connection;
}

export function destroyDevice() {
  if (twilioDevice) {
    twilioDevice.destroy();
    twilioDevice = null;
  }
}

export function disconnectAll() {
  if (twilioDevice) {
    twilioDevice.disconnectAll();
  }
}

export function createDevice(token) {
  twilioDevice = new Device(token, {
    debug: process.env.NODE_ENV !== 'production',
    dscp: true,
  });
  twilioDevice.register();
}
